import React from 'react';
import styles from './PaymentTokens.module.scss';
import { ScrollableContainerPresenter } from '../../atom/ScrollableContainer';
import PaymentTokenItem, { PaymentTokenItem as PaymentToken } from './PaymentTokenItem';

export interface PaymentTokensViewProps {
  tokens: PaymentToken[];
  isLoading?: boolean;
  maxHeight?: string;
}

export default function PaymentTokensView({
  tokens,
  isLoading = false,
  maxHeight = '300px'
}: PaymentTokensViewProps) {

  if (isLoading) {
    return (
      <div className={styles.tokensContainer}>
        <div className={styles.header}>
          <h3>Paiements</h3>
        </div>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
          <span>Chargement des paiements...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.tokensContainer}>
      <div className={styles.header}>
        <h3>Paiements</h3>
        <span className={styles.count}>{tokens.length} tokens</span>
      </div>
      
      <ScrollableContainerPresenter maxHeight={maxHeight}>
        <div className={styles.tokensList}>
          {tokens.length === 0 ? (
            <div className={styles.emptyState}>
              <span>Aucun paiement</span>
            </div>
          ) : (
            tokens.map((token) => (
              <PaymentTokenItem key={token.id} token={token} />
            ))
          )}
        </div>
      </ScrollableContainerPresenter>
    </div>
  );
}
